<vo-sidenav #vosidenav>
  <ng-container
    *ngFor="let child of data?.children"
    [ngTemplateOutlet]="sidenav"
    [ngTemplateOutletContext]="{ $implicit: child, navigation: 'Main menu', parent: undefined }" />

  <ng-template #sidenav let-section let-navigation="navigation" let-parent="parent">
    <vo-sidenav-section [title]="section.label" [navigation]="navigation">
      <button
        *ngIf="parent"
        vo-sidenav-panel
        variant="secondary"
        [parentNavigation]="navigation"
        voSidenavNavigation
        [navigateBack]="true">
        <vo-icon voSidenavPanelPrefix icon="FarChevronLeft" />
        {{ parent }}
      </button>

      <ul vo-list [noMarker]="true">
        <li *ngFor="let child of section.children">
          <a
            *ngIf="child.type === 'Link'; else subSection"
            vo-sidenav-panel
            vmRouting
            [parentNavigation]="navigation"
            [href]="child.href"
            (click)="closeSideNav($event)">
            <vo-icon
              *ngIf="child.icon"
              voSidenavPanelPrefix
              [icon]="child.icon | strapiIcon"
              size="md"
              iconSet="regular" />
            {{ child.label }}
          </a>

          <ng-template #subSection>
            <button vo-sidenav-panel voSidenavNavigation [navigateTo]="child.label" [parentNavigation]="navigation">
              <vo-icon
                *ngIf="child.icon"
                voSidenavPanelPrefix
                [icon]="child.icon | strapiIcon"
                size="md"
                iconSet="regular" />
              {{ child.label }}
              <vo-icon voSidenavPanelSuffix icon="FasChevronRight" size="sm" />
            </button>

            <ng-container
              [ngTemplateOutlet]="sidenav"
              [ngTemplateOutletContext]="{ $implicit: child, navigation: child.label, parent: navigation }" />
          </ng-template>
        </li>
      </ul>
    </vo-sidenav-section>
  </ng-template>
</vo-sidenav>
